module.exports = __webpack_public_path__ + "img/icon_sport_type_20.0e44adc8.png";